import React, { useState, useEffect, useRef } from 'react';
import { List, Datagrid, FunctionField, SimpleList, useRefresh } from 'react-admin';
import { useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, Paper, Typography, Tooltip, Button, Portal, DialogActions, DialogContent, DialogTitle, CircularProgress, Dialog, IconButton, Menu, List as MuiList, ListItem, ListItemText, TablePagination, TableContainer, Table, TableRow, TableHead, TableBody, TableCell, withStyles } from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import moment from 'moment'
import CustomSearch from './components/CustomSearch';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import { useLocation, useHistory } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import ShowTimePeriod from './components/ShowTimePeriod';
import notify from './components/CustomUseNotify';
import "./css/ValetUsers.css";
import Skeleton from '@material-ui/lab/Skeleton';
import config from "./config.json"
import queryString from 'query-string';
import { saveTokens } from './utils/saveTokens';
import CustomFilter from './components/CustomFilter';
import { Helmet } from "react-helmet";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import DownloadImg from './images/download_img.png';
import HandCoins from './images/hand_coins_img.png';
import EyeImg from './images/eye_img.png';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    timeFilterContainer: {
        alignItems: "center",
        marginTop: customTheme.spacing(5),
    },
    timeFilterInput: {
        marginLeft: "2%",
    },
    outlinedInput: {
        padding: 0,
    },
    timeFilterButton: {
        marginLeft: "1%",
        width: "10%",
        minWidth: 85
    },
    summaryListRoot: {
        marginTop: customTheme.spacing(2),
    },
    summaryCardContainer: {
        display: "grid",
        gridAutoFlow: "column",
        marginTop: customTheme.spacing(3),
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
    listActions: {
        justifyContent: "space-between",
        marginTop: customTheme.spacing(3),
    },
    mainTableCell: {
        color: `${customTheme.palette.grey[900]} !important`,
        fontWeight: 500,
    },
    listVehicleIcon: {
        width: 25,
        height: 25,
        marginRight: customTheme.spacing(1),
        verticalAlign: "middle",
    },
    showLayoutMain: {
        marginTop: 0,
    },
    showTitle: {
        fontSize: 22,
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    removeMargin: {
        margin: 0,
    },
    parkingListHead: {
        color: customTheme.palette.grey[500],
    },
    inlineForm: {
        display: "grid",
        gridAutoFlow: "column",
        padding: "18px 2%",
        marginLeft: 15
    },
    removeUnderline: {
        borderBottom: "none",
    },
    checkIconButton: {
        borderRadius: 4,
        padding: "5px 5px 2px",
        '&:hover': {
            backgroundColor: "#0001 !important",
            cursor: "pointer",
        },
    },
    smallSelectRoot: {
        padding: "10px 32px 10px 18px",
    },
    receiptTextContainer: {
        display: "flex",
        padding: "15px 20px",
        '&:hover': {
            backgroundColor: "#00336608",
        },
        alignItems: "center",
        marginBottom: 15,
        border: "1px solid #bfbfbf",
        borderRadius: 4,
    },
    selectWithIcon: {
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: 20,
        paddingRight: "40px !important",
        columnGap: 30,
    },
    editSummaryTime: {
        color: "#888",
        fontSize: 20,
        marginLeft: 10,
        '&:hover': {
            cursor: "pointer",
            opacity: 0.7,
        }
    },
    backDrop: {
        backgroundColor: "#00000042"
    },
    statusCircle: {
        width: 7,
        height: 7,
        borderRadius: 10,
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    timeRangeButton: {
        flex: 1,
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#eee"
        }
    },
    title: {
        fontSize: 13,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 28,
        color: customTheme.palette.primary.main,
        fontWeight: customTheme.typography.fontWeightRegular
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    summaryVehicleIcon: {
        width: 18
    },
    summaryBoxLabel1: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    paymentSummaryBoxLabel1: {
        fontSize: 12,
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 12,
        color: "#334D6E",
        fontWeight: customTheme.typography.fontWeightMedium
    },
    tooltip: {
        fontSize: 9,
        fontFamily: "Poppins-Regular",
        fontWeight: "normal"
    }
});

const StyledTableCell = withStyles((theme) => ({
    root: {
        fontSize: 13,
        borderBottomColor: customTheme.palette.divider,
        padding: "15px 5px !important",
    },
    head: {
        fontWeight: 500,
        color: customTheme.palette.grey[700],
    },
    body: {
        fontWeight: 400,
        color: "#707683",
    },
}))(TableCell);

const ShiftDetailsSkeleton1 = props => <Skeleton variant="text" height={18} width={160} style={{ display: "inline-block", transform: "none" }} {...props} />;

const STATUS = {
    "Paid": { label: "Paid", color: "#18CC69", backgroundColor: "#18CC6919", padding:"1px 4px", borderRadius: "5px" },
    "Not Paid": { label: "Not Paid", color: "#F74E3D", backgroundColor: "#F74E3D19", padding:"1px 4px", borderRadius: "5px" },
    "Not Billed": { label: "Not Billed", color: "#D2A100", backgroundColor: "#D2A10019", padding:"1px 4px", borderRadius: "5px" },
    "default": { color: "#334D6E", backgroundColor: "#EBEFF2", padding:"1px 4px", borderRadius: "5px" }
};

let summaryDetailsInitState = {
    "data": {
        "Current Bill": {
            "amount": "",
            "billing_start_date": "",
            "billing_end_date": ""
        },
        "New Users Onboarded": {
            "totalSum": "",
            "newUser": "",
            "deletedUser": ""
        },
        "Next Billing On": {
            "billing_date": ""
        },
        "Per User Cost": {
            "amount": ""
        },

    },
    "loading": true,
    "isInitState": true
}

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const PermitUsersBilling = (props) => {
    const classes = useStyles()
    const listDataRef = useRef();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Invoice ID"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Invoice ID");

    const [showTiles, setShowTiles] = useState(true)
    const [summaryDetails, setSummaryDetails] = useState(summaryDetailsInitState)
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key_id: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    let filterTypesInitState = [
        {
            filterType: "Status",
            dataList: [{ name: "Paid", id: 1 }, { name: "Not Paid", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getSummaryDetails = () => {
        setSummaryDetails({ loading: true, data: summaryDetailsInitState.data, isInitState: true })
        const params = {
            filter: JSON.stringify({
                access_key_id: currentParking.id,
                parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
                start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
                end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            })
        }
        fetch(`${config.HOST_NAME}/crm/billing/permit-users/tile?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setSummaryDetails({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    useEffect(() => {
        if (currentParking && currentParking.id) getSummaryDetails()
    }, [currentParking, startDateTime, endDateTime]); // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        let values = {}
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Status") values = { ...values, status: filterListValue[val].value ? filterListValue[val].value : undefined }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) setSettingFilterFormat({})
    }, [filterListValue])


    return (
        <div>
            <Helmet>
                <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
            </Helmet>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} hideCurrentDate={true} />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} />
            </div>
            <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={showTiles} setShowTiles={setShowTiles} />

            {currentParking && currentParking.id ?
                <>
                    {showTiles &&
                        <>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                                <SummaryCard loading={summaryDetails.loading} title="Current Bill" isAmount={true} mainValue={summaryDetails["data"]["Current Bill"].amount} date={`${moment(summaryDetails["data"]["Current Bill"].billing_start_date).format("MMM DD")} - ${moment(summaryDetails["data"]["Current Bill"].billing_end_date).format("MMM DD")}`} percentage={false} />
                                <SummaryCard loading={summaryDetails.loading} title="New Users Onboarded" isAmount={false} mainValue={summaryDetails["data"]["New Users Onboarded"].totalSum} date={false} percentage={true} newUsers={summaryDetails["data"]["New Users Onboarded"].newUser} deletedUsers={summaryDetails["data"]["New Users Onboarded"].deletedUser} />
                                <SummaryCard loading={summaryDetails.loading} title="Next Billing On" isAmount={false} mainValue={moment(summaryDetails["data"]["Next Billing On"].billing_date).format("DD MMM YYYY")} date={false} percentage={false} />
                                <SummaryCard loading={summaryDetails.loading} title="Per User Cost" isAmount={true} mainValue={summaryDetails["data"]["Per User Cost"].amount} date={false} percentage={false} />
                            </div>
                        </>
                    }

                    {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#F0FEEF", marginTop: 30, marginBottom: 20, padding: 16 }}>
                <div style={{ flex: 1, display: "flex" }}>
                    <img src={PayBillIcon} style={{ width: 40, height: 40, marginRight: 15 }} alt='Pay Bill' />

                    <div style={{ color: "#3D3D3D" }}>
                        <div style={{ fontSize: 13, fontWeight: 600 }}>Pay Bill</div>
                        <div style={{ fontSize: 12 }}>An invoice of ₹20,2021 generated for the Bill Cycle (1 Jul - 31 July) has been generated.</div>
                    </div>
                </div>
                <div>
                    <RechargeButton label={false} />
                </div>
            </div> */}

                    <div className='secondaryColor fontWeightSemiBold' style={{ fontSize: 14, marginTop: 10 }}>Invoices</div>
                    <List
                        {...props}
                        style={{ marginTop: 10 }}
                        empty={false}
                        filter={filter}
                        title="Permit Users Billing"
                        bulkActionButtons={false}
                        exporter={false}
                        actions={false}
                        pagination={<CustomPagination setListData={(listData) => { listDataRef.current = listData }} />}
                    >

                        {isSmallDevice ?
                            <SimpleList
                                primaryText={record => record && record.ref_id ? `${record.ref_id}` : "-"}
                                secondaryText={record => (<div>
                                    {record.total_amount && <div><span style={{ color: "#5a5a5a" }}>Total Amount: </span>₹ {record.total_amount}</div>}
                                    {record.billing_period && <div><span style={{ color: "#5a5a5a" }}>Billing Period: </span>{record.billing_period}</div>}
                                    {record.status && <div><span style={{ color: "#5a5a5a" }}>Status: </span>{STATUS[record.status].label}</div>}
                                    {record.paid_on && <div><span style={{ color: "#5a5a5a" }}>Paid On: </span>{moment(record["paid_on"]).format("YYYY-MM-DD hh:mm:ss")}</div>}
                                    {record.total_users && <div><span style={{ color: "#5a5a5a" }}>Parking: </span>{record.total_users}</div>}
                                </div>)}
                                onContextMenu={event => event.preventDefault()}
                                linkType={false}
                                rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                            />
                            :
                            <Datagrid className='permitUsersBillingDataGrid' component={ScrollableTable}>
                                <FunctionField source="ref_id" label="Invoice ID" sortable={false} render={record => record && record.ref_id ? `${record.ref_id}` : "-"} />
                                <FunctionField source="total_amount" label="Total Amount" sortable={false} render={record => record && record.amount ? `₹ ${record.amount}` : "-"} />
                                <FunctionField source="billing_period" label="Billing Period" sortable={false} render={record => record && record.billing_start && record.billing_end ? `${moment(record.billing_start).format("D MMM YY")} - ${moment(record.billing_end).format("D MMM YY")}` : "-"} />
                                <FunctionField source='status' label="Status" sortable={false}
                                    render={record => record && (
                                        <div className='fontWeightBold' style={{ width: 50, fontSize: 11, textTransform: "capitalize", ...STATUS[record.status] }}>{record.status ? record.status : "NA"}</div>
                                    )}
                                />
                                <FunctionField source="paid_on" label="Paid On" render={record => record && record.paid_on ? moment(record.paid_on).format("MMM DD YY") : "-"} />
                                <FunctionField source="total_count" label="Total Users" sortable={false} render={record => record && record.total_count ? record.total_count : "-"} />
                                <RechargeButton label={false} />
                                <InvoiceSettings label={false} accessKeyId={currentParking.id} startTime={startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : ""} endTime={endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : ""} />
                            </Datagrid>
                        }
                    </List>

                </>
                :
                <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", marginTop: 10 }}>
                    <div style={{ color: "#334D6E", fontSize: 13, fontFamily: "Poppins-Medium" }}>Please select a Parking.</div>
                </Paper>
            }
        </div>
    )
};

const SummaryCard = ({ loading, title, mainValue, date = false, newUsers = false, percentage = false, deletedUsers = false, isAmount = false }) => {
    const classes = useStyles()
    return <Paper style={{ position: "relative", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px" }}>
        <div style={{ flex: 1 }}>
            <div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 24 }}>
                    <Typography className={classes.title} style={{ fontSize: 14, color: "#7C7C7C", textTransform: "capitalize" }}>{title}</Typography>
                </div>
                {
                    !loading && mainValue ?
                        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                            <Typography className={classes.mainValue} style={{ color: "#3D3D3D", fontSize: 20 }}>{isAmount ? `₹ ${mainValue}` : mainValue}</Typography>
                            {date && <Typography style={{ color: "#7C7C7C", fontSize: 12, marginRight: 10 }}>({date})</Typography>}
                        </div>
                        :
                        !loading && !mainValue ?
                            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                                <Typography className={classes.mainValue} style={{ color: "#3D3D3D", fontSize: 20 }}>{isAmount ? `₹ 00.00` : 0}</Typography>
                            </div>
                            :
                            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                                <Skeleton variant="text" height={36} width="100px" />
                                {date && <Skeleton variant="text" height={36} width="80px" />}
                            </div>
                }

                {Boolean(newUsers) && Boolean(deletedUsers) &&
                    <div className="horizontal-bar" style={{ width: "100%", marginTop: 16 }}>
                        <Tooltip arrow title={`New Onboarded ${newUsers}`} classes={{ tooltip: classes.tooltip }}>
                            <div className="bar-segment" style={{ width: `50%`, backgroundColor: "#18CC69", marginRight: 5 }}>
                            </div>
                        </Tooltip>
                        <Tooltip arrow title={`Delete Users ${deletedUsers}`} classes={{ tooltip: classes.tooltip }}>
                            <div className="bar-segment" style={{ width: `50%`, backgroundColor: "#FFA610" }}>
                            </div>
                        </Tooltip>
                    </div>
                }
            </div>
        </div>
    </Paper>
}

const DownloadInvoice = (invoiceId) =>{
    const params = {id: invoiceId}
    fetch(`${config.HOST_NAME}/crm/v3/invoices/download?${queryString.stringify(params)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
        },
    }).then(response => {
        saveTokens(response)
        return response.json()
    })
        .then(responseJson => {
            if (responseJson.success) {
                const url = responseJson?.data?.url
                if(url) window.open(url, '_blank');
            }
            else notify(responseJson.message, 'warning');
        })
        .catch((e) => {
            console.log(e)
            notify('Error Fetching Summary', 'warning')
        })
}

function RechargeButton(props) {
    const { record } = props;
    const refresh = useRefresh();
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);

    const updatePermitUsersBillingPaymentStatus = async (transactionId, paymentStatus, remarks) => {
        fetch(`${config.HOST_NAME}/crm/permitUsersBilling/${transactionId}/status`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ payment_status: paymentStatus, remarks: remarks, id: record.id })
        });
    };

    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    };

    // const finishPayment = async (event) => {
    //     event.preventDefault();
    //     closePaymentFailedDialog();
    //     setLoading(true);
    //     fetch(`${config.HOST_NAME}/crm/initiatePermitUsersBillingPayment`, {
    //         method: 'POST',
    //         headers: {
    //             'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
    //             'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({ id: record.id, total_amount: record.total_amount })
    //     })
    //         .then(response => {
    //             saveTokens(response)
    //             return response.json()
    //         })
    //         .then(json => {
    //             if (json.success) {
    //                 const order = json.data.order;
    //                 var options = {
    //                     description: 'Permit Users Billing',
    //                     currency: order.currency,
    //                     key: config.RAZOR_PAY_KEY_ID,
    //                     amount: order.amount,
    //                     name: 'ParkSmart',
    //                     order_id: order.id,
    //                     notes: {
    //                         id: record.id,
    //                         total_amount: record.total_amount
    //                     },
    //                     theme: {
    //                         color: customTheme.palette.primary.main
    //                     },
    //                     modal: {
    //                         ondismiss: () => {
    //                             setLoading(false);
    //                             const description = "Payment is cancelled by user";
    //                             setPaymentFailedDialog(description);
    //                             updatePermitUsersBillingPaymentStatus(json.data.transaction_id, "CANCELLED", description);
    //                         }
    //                     },
    //                     handler: checkoutData => {
    //                         fetch(`${config.HOST_NAME}/crm/verifyPermitUsersBillingPayment`, {
    //                             method: 'POST',
    //                             headers: {
    //                                 'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
    //                                 'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
    //                                 'Content-Type': 'application/json'
    //                             },
    //                             body: JSON.stringify({ ...checkoutData, transaction_id: json.data.transaction_id, id: record.id }),
    //                         })
    //                             .then(response => {
    //                                 saveTokens(response)
    //                                 return response.json()
    //                             })
    //                             .then(json => {
    //                                 setLoading(false);
    //                                 if (json.success) {
    //                                     notify("Payment Successful", "success");
    //                                     refresh();
    //                                 } else {
    //                                     setPaymentFailedDialog(json.message);
    //                                 }
    //                             })
    //                             .catch((error) => {
    //                                 setLoading(false);
    //                                 setPaymentFailedDialog("Could not verify Payment");
    //                             });
    //                     },
    //                 }
    //                 const razorpay = new window.Razorpay(options);
    //                 razorpay.on('payment.failed', function ({ error }) {
    //                     setLoading(false);
    //                     let description, status;
    //                     if (isJsonString(error.description)) {
    //                         const errorObj = JSON.parse(error.description);
    //                         if (errorObj.error) {
    //                             description = errorObj.error.description;
    //                             status = errorObj.error.reason;
    //                         } else {
    //                             description = errorObj.description;
    //                             status = errorObj.reason;
    //                         }
    //                     } else {
    //                         description = error.description;
    //                     }
    //                     setPaymentFailedDialog(description);
    //                     updatePermitUsersBillingPaymentStatus(json.data.transaction_id, status === "payment_cancelled" ? "CANCELLED" : "FAILED", description);
    //                 });

    //                 razorpay.open();
    //             } else {
    //                 setLoading(false);
    //                 notify(json.message, "warning");
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             setLoading(false);
    //             notify("Check your internet connection", "warning");
    //         });
    // };

    // if (!record) return null

    return (
        <div>
           <Button
                className='addBorderRadius'
                onClick={() => DownloadInvoice(record.id)}
                color="primary"
                variant="contained"
                style={{ textTransform: "none", fontSize: 13, fontWeight: 500, letterSpacing: "0.06em", height: "35px", minWidth: "120px", backgroundColor: "#18CC69", color: "#FFF", cursor:"pointer" }}
                disableElevation
                // disabled={loading}
                // disabled={true}
            >
                <img src={HandCoins} alt='Hand Coins' height={18} width={18} style={{ marginRight: 10 }} />  Finish Payment {loading && <CircularProgress size={22} />}
            </Button>

            <Portal>
                <Dialog open={!!paymentFailedDialog} onClose={closePaymentFailedDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.error.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Payment Failed!</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}>Description: {paymentFailedDialog}</DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentFailedDialog}>Cancel</Button>
                        {/* <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={finishPayment}>Retry</Button> */}
                    </DialogActions>
                </Dialog>
            </Portal>
        </div>
    );
}

function InvoiceSettings(props) {
    const navigate = useHistory()
    const { record, accessKeyId, startTime, endTime } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const [settingsMenu, setSettingsMenu] = useState({});

    const openSettingsMenu = (event) => {
        event.preventDefault();
        setSettingsMenu({ mouseX: event.clientX - 2, mouseY: event.clientY - 4 })
    };
    const closeSettingsMenu = () => {
        setSettingsMenu({});
    };

    const openDialog = (type) => {
        if (type === 1) {
            //Redirect to Invoice details
            navigate.push(`/invoices/user-permit/${record.id}?${queryString.stringify({ id: record.id, access_key_id: accessKeyId, start_time: startTime, end_time: endTime, invoice_id: record.id })}`)
        }
        if (type === 2) {
            //Download Invoice
            DownloadInvoice(record.id)
        }
        closeSettingsMenu()
    }

    return (
        <div style={{ display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            <IconButton size='small' onClick={(e) => openSettingsMenu(e)} style={{ color: "#334D6E" }}><MoreHorizIcon /></IconButton>
            <Menu
                anchorReference="anchorPosition"
                anchorPosition={settingsMenu.mouseY !== null && settingsMenu.mouseX !== null ? { top: settingsMenu.mouseY, left: settingsMenu.mouseX } : { top: 0, left: 0 }}
                keepMounted
                open={Boolean(settingsMenu.mouseX)}
                onClose={closeSettingsMenu}
            >
                <MenuItem onClick={() => openDialog(1)}><img src={EyeImg} alt='Download Icon' height={18} width={18} style={{ marginRight: 10 }} />View Details</MenuItem>
                <MenuItem onClick={() => openDialog(2)}><img src={DownloadImg} alt='Download Icon' height={18} width={18} style={{ marginRight: 10 }} />Download Invoice</MenuItem>
            </Menu>
        </div>
    );
}

let invoiceDataInitState = {
    data: {
        id: "12",
        billing_start: "2024-07-01",
        billing_end: "2024-07-31",
        status: "Not Paid",
        per_api_cost: "4",
        total_api_request: "100",
        amount: "400",
        gst: "18",
        total_amount: "490"
    },
    loading: true
}

const NEW_USERS = "NEW_USERS"
const DELETED_USERS = "DELETED_USERS"

export const PermitInvoiceDetails = () => {
    const location = useLocation()
    const { id, access_key_id, start_time, end_time, invoice_id} = queryString.parse(location.search);
    const [currentTab, setCurrentTab] = useState(NEW_USERS)
    const [invoiceData, setInvoiceData] = useState({})
    const [invoiceDataLoader, setInvoiceDataLoader] = useState(true)

    const getInvoiceDetails = () => {
        setInvoiceData(invoiceDataInitState.data);
        setInvoiceDataLoader(true)
        const params = {
            filter: JSON.stringify({
                type: "permit_user",
                access_key_id,
                start_time,
                end_time
            })
        }
        fetch(`${config.HOST_NAME}/crm/v3/invoices/view/${id}?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        }).then(responseJson => {
            if (responseJson.success) setInvoiceData(responseJson.data);
            else notify(responseJson.message, 'warning');
        })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            }).finally(() => {
                setInvoiceDataLoader(false)
            })
    }

    useEffect(() => {
        getInvoiceDetails()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    return <div style={{ padding: "10px 0px", marginTop: 10, fontSize: 14 }}>
        <div style={{ position:"absolute", top: 80, right: 0 }}>
            {/* <div className='fontWeightSemiBold' style={{ flex: 1, color: "#3D3D3D" }}>Invoice Details</div> */}
            <Button className='addBorderRadius' color="primary" variant="contained" disableElevation
                onClick={() => DownloadInvoice(invoice_id)}
                style={{ textTransform: "none", fontSize: 13, fontWeight: 500, letterSpacing: "0.06em", height: "37px", minWidth: "120px", backgroundColor: "#FFF", color: "#3D3D3D", marginRight: 30, border: "1px solid #DCDCDC" }}
            >
                <img src={DownloadImg} alt='Download Icon' height={18} width={18} style={{ marginRight: 10 }} />  Download Invoice
            </Button>
            {/* <RechargeButton label={false} /> */}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 0, width: 350 }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Invoice ID</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{invoiceData.ref_id ? `#${invoiceData.ref_id}` : "NA"}</div>}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: 350 }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Billing Period</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{invoiceData.billing_start && invoiceData.billing_end ? `${moment(invoiceData.billing_start).format("D MMM YY")} - ${moment(invoiceData.billing_end).format("D MMM YY")}` : "NA"}</div>}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: 350 }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Status</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D", ...STATUS[invoiceData.status] }}>{invoiceData.status ? invoiceData.status : "NA"}</div>}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: 350 }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Total Users</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{invoiceData.total ? invoiceData.total : "0"}</div>}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: 350 }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Deleted Users</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{invoiceData.delete_user ? invoiceData.delete_user : "0"}</div>}
        </div>

        <div className='fontWeightSemiBold' style={{ marginTop: 25, color: "#3D3D3D" }}>Amount Breakdown</div>
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: "100%" }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Per User Cost</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{invoiceData.cost ? ` ₹${invoiceData.cost}` : "NA"}</div>}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: "100%" }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Total Users Onboarded</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{invoiceData.total ? `${invoiceData.total}` : "0"}</div>}
        </div>
        {/* <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: "100%" }}>
            <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>Amount</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{invoiceData.amount ? `₹ ${invoiceData.amount}` : "NA"}</div>}
        </div> */}

        {invoiceData && invoiceData.taxes && invoiceData.taxes[0] &&
            invoiceData.taxes.map((val) => {
                return <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: "100%" }}>
                    <div className='fontWeightMedium' style={{ color: "#7C7C7C", flex: 1 }}>{val.tax_name}</div>
                    {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightMedium' style={{ color: "#3D3D3D" }}>{val.tax_amount ? `₹ ${val.tax_amount}` : "NA"}</div>}
                </div>
            })
        }

        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginTop: 15, width: "100%" }}>
            <div className='fontWeightSemiBold' style={{ color: "#7C7C7C", flex: 1, fontSize: 15 }}>Total Amount</div>
            {invoiceDataLoader ? <Skeleton variant="text" width={50} height={18} /> : <div className='fontWeightSemiBold' style={{ color: "#3D3D3D", fontSize: 15 }}>{invoiceData.amount ? `₹ ${invoiceData.amount}` : "NA"}</div>}
        </div>

        <div className='fontWeightSemiBold' style={{ flex: 1, color: "#3D3D3D", marginTop: 25, marginBottom: 20 }}>Users Onboarded</div>

        <div style={{ display: "flex", alignItems: "center", columnGap: 10, fontSize: 12}}>
            <div onClick={() => setCurrentTab(NEW_USERS)} style={{ borderBottom: currentTab === NEW_USERS ? "solid 2px #18CC69" : "#FFF", color: currentTab === NEW_USERS ? "#18CC69" : "#999", padding: "8px 25px", cursor:'pointer', fontWeight: currentTab === NEW_USERS ?  'bold' : 'normal' }}>
               New Users
            </div>
            <div onClick={() => setCurrentTab(DELETED_USERS)} style={{ borderBottom: currentTab === DELETED_USERS ? "solid 2px #18CC69" : "#FFF", color: currentTab === DELETED_USERS ? "#18CC69" : "#999", padding: "8px 25px", cursor:'pointer', fontWeight: currentTab === DELETED_USERS ?  'bold' : 'normal' }}>
                Deleted Users
            </div>
        </div>

        {currentTab === NEW_USERS && <NewUsersList />}
        {currentTab === DELETED_USERS && <DeletedUsersList/>}

    </div>
};

const NewUsersList = () => {
    const location = useLocation()
    const classes = useStyles()
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const { access_key_id, start_time, end_time } = queryString.parse(location.search);
    const [invoiceTableData, setInvoiceTableData] = useState([])
    const [invoiceTableDataLoader, setInvoiceTableDataLoader] = useState(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [totalVehicleCount, setTotalVehicleCount] = useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getInvoiceTableDetails = () => {
        setInvoiceTableDataLoader(true)
        const params = {
            filter: JSON.stringify({
                access_key_id,
                start_time,
                end_time,
                page: page,
                perPage: rowsPerPage,
            })
        }

        fetch(`${config.HOST_NAME}/crm/v3/invoices/getInvoiceNewUsers?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        }).then(responseJson => {
            if (responseJson.success) {
                setInvoiceTableData(responseJson.data);
                if (responseJson.totalLength > 25) setTotalVehicleCount(25)
                else setTotalVehicleCount(responseJson.totalLength);
            }
            else notify(responseJson.message, 'warning');
        })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            }).finally(() => {
                setInvoiceTableDataLoader(false)
            })
    }

    useEffect(() => {
        getInvoiceTableDetails()
    }, [page, rowsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps


    return <>
    {!invoiceTableDataLoader && !invoiceTableData[0] ?
            <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px" }}>
                <div style={{ color: "#334D6E", fontSize: 13, fontFamily: "Poppins-Medium" }}>No data found.</div>
            </Paper>
            : <>
                {isSmallDevice &&
                    <MuiList>
                        {invoiceTableData.map((row, index) => {
                            return (<ListItem alignItems="flex-start" style={{ paddingLeft: 10, paddingRight: 10, borderBottom: "1px solid #18cc69" }}>
                                <ListItemText
                                    primary={row.vehicle_number}
                                    secondary={<div>
                                        {row.username && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{row.username}</div>}
                                        {row.vehicle_number && <div><span style={{ color: "#5a5a5a" }}>Vehicle Number: </span>{row.vehicle_number}</div>}
                                    </div>}
                                />
                            </ListItem>)
                        })}
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            count={totalVehicleCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </MuiList>

                }

                {!isSmallDevice &&
                    <Paper style={{ width: "100%", mb: 2, boxShadow: "0px 4px 15px #0000001a" }}>
                        <TableContainer component={ScrollableTable} style={{ boxShadow: "none" }}>
                            <Table size="small" style={{ padding: 0 }}>
                                <TableHead style={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>
                                    <TableRow>
                                        <StyledTableCell>Name</StyledTableCell>
                                        <StyledTableCell>User Type</StyledTableCell>
                                        <StyledTableCell>RFID</StyledTableCell>
                                        <StyledTableCell>Flat No.</StyledTableCell>
                                        <StyledTableCell>Tower Name</StyledTableCell>
                                        <StyledTableCell>Company</StyledTableCell>
                                        <StyledTableCell>Created On</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoiceTableData ?
                                        invoiceTableData.map((row, index) => (<TableRow key={row["id"]}>
                                            <StyledTableCell>{row.username ? row.username : "-"}</StyledTableCell>
                                            <StyledTableCell style={{textTransform:"capitalize"}}>{row.user_type ? row.user_type : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.rfid ? row.rfid : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.society_flat_number ? row.society_flat_number : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.society_tower_name ? row.society_tower_name : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.organization ? row.organization : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.created_on ? moment(row.created_on).format("D MMM YY") : "-"}</StyledTableCell>
                                        </TableRow>))
                                        :
                                        [1, 2, 3].map((row) => (<TableRow key={row}>
                                            <StyledTableCell component="th" scope="row" className={classes.mainTableCell}><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                        </TableRow>))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            count={invoiceTableData ? invoiceTableData.length : 0}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Paper>
                }
            </>
        }
    </>
}

const DeletedUsersList = () => {
    const location = useLocation()
    const classes = useStyles()
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const { access_key_id, start_time, end_time} = queryString.parse(location.search);
    const [invoiceTableData, setInvoiceTableData] = useState([])
    const [invoiceTableDataLoader, setInvoiceTableDataLoader] = useState(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [totalVehicleCount, setTotalVehicleCount] = useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getInvoiceTableDetails = () => {
        setInvoiceTableDataLoader(true)
        const params = {
            filter: JSON.stringify({
                access_key_id,
                start_time,
                end_time,
                page: page,
                perPage: rowsPerPage,
            })
        }

        fetch(`${config.HOST_NAME}/crm/v3/invoices/getInvoiceDeletedUsers?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        }).then(responseJson => {
            if (responseJson.success) {
                setInvoiceTableData(responseJson.data);
                if (responseJson.totalLength > 25) setTotalVehicleCount(25)
                else setTotalVehicleCount(responseJson.totalLength);
            }
            else notify(responseJson.message, 'warning');
        })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            }).finally(() => {
                setInvoiceTableDataLoader(false)
            })
    }

    useEffect(() => {
        getInvoiceTableDetails()
    }, [page, rowsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps


    return <>
    {!invoiceTableDataLoader && !invoiceTableData[0] ?
            <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px" }}>
                <div style={{ color: "#334D6E", fontSize: 13, fontFamily: "Poppins-Medium" }}>No data found.</div>
            </Paper>
            : <>
                {isSmallDevice &&
                    <MuiList>
                        {invoiceTableData.map((row, index) => {
                            return (<ListItem alignItems="flex-start" style={{ paddingLeft: 10, paddingRight: 10, borderBottom: "1px solid #18cc69" }}>
                                <ListItemText
                                    primary={row.vehicle_number}
                                    secondary={<div>
                                        {row.username && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{row.username}</div>}
                                        {row.vehicle_number && <div><span style={{ color: "#5a5a5a" }}>Vehicle Number: </span>{row.vehicle_number}</div>}
                                    </div>}
                                />
                            </ListItem>)
                        })}
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            count={totalVehicleCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </MuiList>

                }

                {!isSmallDevice &&
                    <Paper style={{ width: "100%", mb: 2, boxShadow: "0px 4px 15px #0000001a" }}>
                        <TableContainer component={ScrollableTable} style={{ boxShadow: "none" }}>
                            <Table size="small" style={{ padding: 0 }}>
                                <TableHead style={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>
                                    <TableRow>
                                        <StyledTableCell>Name</StyledTableCell>
                                        <StyledTableCell>User Type</StyledTableCell>
                                        <StyledTableCell>RFID</StyledTableCell>
                                        <StyledTableCell>Flat No.</StyledTableCell>
                                        <StyledTableCell>Tower Name</StyledTableCell>
                                        <StyledTableCell>Company</StyledTableCell>
                                        <StyledTableCell>Created On</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoiceTableData ?
                                        invoiceTableData.map((row, index) => (<TableRow key={row["id"]}>
                                            <StyledTableCell>{row.username ? row.username : "-"}</StyledTableCell>
                                            <StyledTableCell style={{textTransform:"capitalize"}}>{row.user_type ? row.user_type : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.rfid ? row.rfid : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.society_flat_number ? row.society_flat_number : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.society_tower_name ? row.society_tower_name : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.organization ? row.organization : "-"}</StyledTableCell>
                                            <StyledTableCell>{row.created_on ? moment(row.created_on).format("D MMM YY") : "-"}</StyledTableCell>
                                        </TableRow>))
                                        :
                                        [1, 2, 3].map((row) => (<TableRow key={row}>
                                            <StyledTableCell component="th" scope="row" className={classes.mainTableCell}><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                        </TableRow>))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            count={invoiceTableData ? invoiceTableData.length : 0}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Paper>
                }
            </>
        }
    </>
}